import React from 'react';
import {
	ColorSlider as AriaColorSlider,
	type ColorSliderProps as AriaColorSliderProps,
	SliderOutput,
	SliderTrack,
	composeRenderProps
} from 'react-aria-components';
import { cn } from '../../../components/utils';
import { ColorThumb } from '../../../components/color/ColorThumb';
import { FieldLabel } from '~/shared/forms/controls/base-controls/FieldLabel';

interface ColorSliderFieldProps extends AriaColorSliderProps {
	label?: string;
}

export function ColorSliderField({ label, ...props }: ColorSliderFieldProps) {
	return (
		<AriaColorSlider
			{...props}
			className={composeRenderProps(props.className, className =>
				cn(
					'orientation-horizontal:grid orientation-vertical:flex grid-cols-[1fr_auto] flex-col items-center gap-2 orientation-horizontal:w-56',
					className
				)
			)}
		>
			<FieldLabel>{label}</FieldLabel>
			<SliderOutput className="text-sm font-medium text-gray-500 orientation-vertical:hidden" />
			<SliderTrack
				className={renderProps =>
					cn(
						'orientation-horizontal:h-6 group col-span-2 rounded-lg',
						renderProps.orientation === 'vertical' ? 'ml-[50%] h-56 w-6 -translate-x-[50%]' : 'h-6 w-full',
						renderProps.isDisabled && 'bg-gray-300 forced-colors:bg-[GrayText]'
					)
				}
				style={({ defaultStyle, isDisabled }) => ({
					...defaultStyle,
					background: isDisabled
						? undefined
						: `${defaultStyle.background}, repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px`
				})}
			>
				<ColorThumb />
			</SliderTrack>
		</AriaColorSlider>
	);
}
